<input [id]="id" type="checkbox" class="{{ cssClass }}" [checked]="val" (input)="onChange($event.target.checked)"
	(change)="onChange($event.target.checked)" (blur)="onTouched()" [disabled]="disabled" #controlRef>
<label class="{{ cssClassLabel }}" [attr.for]="id">&nbsp;{{ label }}<itm-required *ngIf="validators?.required">*</itm-required>
	<ng-content></ng-content>
</label>
<!-- <div class="custom-control custom-checkbox">
	<input type="checkbox" class="custom-control-input {{ cssClass }}" [id]="id" [checked]="val"
		(input)="onChange($event.target.checked)" (change)="onChange($event.target.checked)" (blur)="onTouched()"
		[disabled]="disabled" #controlRef>
	<label class="custom-control-label" [attr.for]="id">{{ label }}<itm-required *ngIf="validators?.required">*
		</itm-required>
		<ng-content></ng-content>
	</label>
</div> -->